import React from 'react';
import './footer1.less';

import TweenOne from 'rc-tween-one';
import OverPack from 'rc-scroll-anim/lib/ScrollOverPack';
import QueueAnim from 'rc-queue-anim';
import { Row, Col, Popover } from 'antd';
import { getChildrenToRender, isImg } from '@/utils/utils';
import Footer2 from './Footer2';
import { Footer21DataSource } from '../data.source';
import UserInfoModal from '../../components/userInfoModal/UserInfoModal.jsx';

class Footer extends React.Component {
  static defaultProps = {
    className: 'footer1',
  };

  state = {
    showUserInfoModal: false,
  };

  handleOpenModal = () => {
    this.setState({ showUserInfoModal: true });
  };

  handleCloseModal = () => {
    this.setState({ showUserInfoModal: false });
  };
  getQrcodeRender = (data)=>{
    const content = (
      <div style={{width:'160px',}}>
        <img src={data.children} width="100%" alt="img" />
      </div>
    )
    return(
      <div {...data} key={data.children}>
        {/*<Popover content={content} >*/}
          <img src={data.children} width="100%" alt="img" />
        {/*</Popover>*/}
        {/* {data.children} */}
      </div>
    )
  }
  getLiChildren = (data) =>
    data.map((item, i) => {
      const { title, childWrapper, ...itemProps } = item;
      return (
        <Col key={i.toString()} {...itemProps} title={null} content={null}>
          <h2 {...title}>
            {typeof title.children === 'string' &&
            title.children.match(isImg) ? (
              <img src={title.children} width="100%" alt="img" />
            ) : (
              title.children
            )}
          </h2>
          <div {...childWrapper}>
            {
              itemProps.name === "qrcode"
                ? childWrapper.children.map(this.getQrcodeRender)
                : childWrapper.children.map((child, index) => {
                    // 检查是否是"了解更多"按钮
                    if (child.children === '了解更多') {
                      // 创建一个新的对象，替换href为onClick
                      const newChild = {
                        ...child,
                        href: undefined,
                        onClick: this.handleOpenModal,
                        className: `${child.className || ''} learn-more-btn`,
                      };
                      return getChildrenToRender(newChild, index);
                    }
                    return getChildrenToRender(child, index);
                  })
            }
          </div>
        </Col>
      );
    });


  render() {
    const { ...props } = this.props;
    const { dataSource } = props;
    delete props.dataSource;
    delete props.isMobile;
    const childrenToRender = this.getLiChildren(dataSource.block.children);
    // const qrcodeRender = this.getQrcode(dataSource.qrcode.children);
    return (
      <div {...props} {...dataSource.wrapper}>
        <OverPack {...dataSource.OverPack}>
          <QueueAnim
            type="bottom"
            key="ul"
            leaveReverse
            component={Row}
            {...dataSource.block}
          >
            {childrenToRender}
            {/* {qrcodeRender} */}
          </QueueAnim>

          <Footer2 dataSource={Footer21DataSource}/>
          <TweenOne
            animation={{ y: '+=30', opacity: 0, type: 'from' }}
            key="copyright"
            {...dataSource.copyrightWrapper}
          >
            <div {...dataSource.copyrightPage}>
              <div {...dataSource.copyright}>
                {dataSource.copyright.children}
              </div>
            </div>
            <div className='backup-num'>
            <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2025141059号</a>
            </div>
          </TweenOne>
        </OverPack>

        {/* 用户信息弹窗 */}
        <UserInfoModal
          visible={this.state.showUserInfoModal}
          onCancel={this.handleCloseModal}
        />
      </div>
    );
  }
}

export default Footer;
